var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.157,
    height: 19.427,
    viewBox: "0 0 21.157 19.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.01 -13.969)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.461,47.371a2.959,2.959,0,1,0-2.324,2.315A2.96,2.96,0,0,0,51.461,47.371Z",
    transform: "translate(-28.106 -23.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.32,16.817a9.646,9.646,0,0,0-6.865-2.848,9.746,9.746,0,0,0-9.571,8.07H9.45a.423.423,0,0,0-.314.724l2.386,2.554a.483.483,0,0,0,.351.154h0a.483.483,0,0,0,.35-.151l2.427-2.557a.423.423,0,0,0-.313-.725H12.947A7.689,7.689,0,1,1,14.3,28.277h0a.386.386,0,0,0-.548-.071l-.986.782a.386.386,0,0,0-.068.535h0a9.711,9.711,0,0,0,17.471-5.84A9.648,9.648,0,0,0,27.32,16.817Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetWhite);
export default __webpack_public_path__ + "static/media/reset-white.94db018b91c4c3a37b62ad20ee55c021.svg";
export { ForwardRef as ReactComponent };